export const environment = {
  production: false,
  appVersion: '7.1.0',
  // apiUrl: 'https://dev.belenus.api-gateway.innovax.cl/graphql',
  // apiUrl: 'https://api-gateway.belenus.cl/graphql',
  apiUrl: 'https://dev.belenus.api-gateway.innovax.cl/graphql',
  // apiUrl: 'http://192.168.1.139:3000/graphql',
  // apiUrl: 'http://192.168.1.139:3000/graphql',
  maps: {
    mapsWebKey: 'AIzaSyCHaMlSpGLlAG0lHbWDV6tPALvHo_kdGNQ',
    mapsIosKey: 'AIzaSyDcDXt33i8u1iKVby0V9miU3lZPIXMfCN0',
  },
  bank: {
    mercadopago: {
      publicKey: 'TEST-fa28ec3d-9764-4f63-96eb-d923eae03e40',
    }
  },
  firebase: {
    apiKey: "AIzaSyAf6T8edEiZsgGN_PgeXuCeqFeJTKtinbs",
    authDomain: "belenus-app-322fb.firebaseapp.com",
    projectId: "belenus-app-322fb",
    storageBucket: "belenus-app-322fb.firebasestorage.app",
    messagingSenderId: "663383796797",
    appId: "1:663383796797:web:785334ecdb7ca1d1118e54",
    measurementId: "G-XWH0WNRC29"
  },
  belenusWspNumber: '56934047167',
  belenusCallCenter: '56232102550',
};
